module.exports = __webpack_public_path__ + "img/img-total.1c9e9259.png";